<template>
  <div class="home-box">
    <PageTitle :title="'Requisition Details'" class="py-5" />
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 home-tabs-body">
        <v-card class="pa-5">
          <v-row>
            <v-col cols="12">
              <v-card class="mb-5 pa-4">
                <v-card-title class="mb-5 pa-4">
                  <span class="headline"
                    >Requisition Code - {{ requisition.code }}</span
                  >
                </v-card-title>
                <v-card-subtitle>
                  <div class="subtitle-lines">
                    <div>
                      <strong>Branch Code:</strong>
                      {{
                        requisition && requisition.branch
                          ? requisition.branch.code
                          : ""
                      }}
                    </div>
                    <div>
                      <strong>Expected Delivery Date:</strong>
                      {{ requisition.expected_delivery_date }}
                    </div>
                    <div>
                      <strong>Status:</strong>
                      <v-chip
                        small
                        dark
                        :color="statusColor(requisition.status)"
                      >
                        {{ stringFormatting(requisition.status) }}
                      </v-chip>
                    </div>
                  </div>
                </v-card-subtitle>
                <div v-if="requisition.comment" class="mt-3">
                  <strong>Comment:</strong> {{ requisition.comment }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <!-- <div class="d-flex align-center mb-4">
            <v-btn
              color="primary"
              @click="storeDialog = true"
              class="mb-4"
              v-if="canTransferAnyItem && requisition.status === 'pending'"
            >
              Select Stores
            </v-btn>
            <v-btn
              color="error"
              small
              class="mb-4 ml-2"
              v-if="
                selectedStores &&
                  selectedStores.length &&
                  requisition.status === 'pending'
              "
              @click="clearSelectedStores"
            >
              Clear selected stores
            </v-btn>
          </div> -->
          <!-- Items Table using ItemsTableTransfer -->
          <ItemsTableTransfer
            v-if="items && items.length > 0"
            :requisitionId="requisitionId"
            :requisitionStatus="requisition.status"
            :requisition="requisition"
            :items="items"
            :productsArray="productsArray"
            :headers="itemHeaders"
            :title="'Items'"
            :readonly="true"
          />

          <v-alert v-else type="info" class="mt-5" outlined>
            No items found for this requisition.
          </v-alert>

          <v-dialog v-model="storeDialog" max-width="600px">
            <v-card>
              <v-card-title>Select Stores</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <div v-if="branches.length">
                      <strong>Branch:</strong> {{ getBranchName(branchId) }}
                    </div>
                    <div style="max-width: 400px;">
                      <v-autocomplete
                        v-model="selectedStores"
                        :items="stores"
                        item-text="store_name"
                        item-value="id"
                        multiple
                        label="Select Stores"
                      ></v-autocomplete>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="storeDialog = false">Cancel</v-btn>
                <v-btn color="primary" @click="confirmStoreSelection">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </div>
    </v-row>
  </div>
</template>

<script>
import ItemsTableTransfer from "@/components/Requisition/ItemsTableTransfer.vue";
import PageTitle from "@/components/shared/PageTitle";
import { RequisitionService } from "@/services/requisition-service.js";
import { StockTransferService } from "@/services/stockTransfer-service.js";

export default {
  name: "RequisitionView",
  components: { PageTitle, ItemsTableTransfer },
  props: {
    id: { type: [String, Number], default: null },
  },
  data() {
    return {
      requisition: {},
      items: [],
      productsArray: [],
      loading: false,
      itemHeaders: [
        { text: "Product", value: "product_id" },
        { text: "Description", value: "description" },
        { text: "Requested Quantity", value: "requested_quantity" },
        {
          text: "Already transfered quantity",
          value: "Already transfered quantity",
        },
        { text: "Quantity Can Transfer", value: "Quantity Can Transfer" },
      ],
      storeDialog: false,
      selectedStores: this.storeIds,
      branches: [],
      stores: [],
    };
  },
  computed: {
    requisitionId() {
      return (this.id ?? this.$route.params.id)?.toString();
    },
    branchId() {
      return this.$route.query.branchId || null;
    },
    storeIds() {
      if (!this.$route.query.storeIds) return [];
      return this.$route.query.storeIds.split(",").map(Number);
    },
    canTransferAnyItem() {
      return this.items.some(
        (item) => item.quantity > item.transferred_quantity
      );
    },
  },
  mounted() {
    this.fetchBranches();
    this.fetchRequisition();
    this.selectedStores = this.storeIds;
  },
  watch: {
    "$route.query.storeIds": {
      handler() {
        this.selectedStores = this.storeIds;
        this.fetchRequisition();
      },
      immediate: false,
    },
  },
  methods: {
    async fetchRequisition() {
      if (!this.requisitionId) {
        return;
      }
      try {
        this.loading = true;
        const response = await RequisitionService.getRequisitionDetailsWithStocks(
          this.requisitionId,
          this.branchId,
          this.storeIds
        );
        const req = response.data;
        this.requisition = req;
        this.items = req.items || [];
        this.productsArray = req.productsarray || [];
        this.checkAndUpdateRequisitionStatus();
      } catch (error) {
        console.error("Error fetching requisition details:", error);
      } finally {
        this.loading = false;
      }
    },

    async checkAndUpdateRequisitionStatus() {
      if (
        this.items.length > 0 &&
        this.items.every(
          (item) =>
            item.quantity === item.transferred_quantity &&
            this.requisition.status == "pending"
        )
      ) {
        this.requisition.status = "Completed";
        try {
          await RequisitionService.updateRequisitionStatus(
            this.requisitionId,
            "Completed"
          );
        } catch (error) {
          console.error("Failed to update requisition status:", error);
        }
      }
    },

    async fetchBranches() {
      try {
        const branchesResponse = await StockTransferService.getMainBranchAndStores();
        this.branches = branchesResponse.data;
        this.stores = this.branches.reduce(
          (acc, branch) => acc.concat(branch.stores || []),
          []
        );
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    },
    statusColor(status) {
      switch (status) {
        case "approved":
          return "green";
        case "pending":
          return "orange";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },
    stringFormatting(status) {
      if (!status) return "";
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    goToList() {
      this.$router.push({ name: "RequisitionsList" });
    },
    getBranchName(branchId) {
      const branch = this.branches.find((b) => b.id == branchId);
      return branch ? branch.name : "";
    },
    confirmStoreSelection() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          storeIds: this.selectedStores.join(","),
        },
      });
      this.storeDialog = false;
      this.fetchRequisition();
    },
    clearSelectedStores() {
      this.selectedStores = [];
      this.$router.replace({
        query: {
          ...this.$route.query,
          storeIds: "",
        },
      });
      this.fetchRequisition();
    },
  },
};
</script>

<style scoped>
.first-row {
  font-weight: bold;
}
.dark-row {
  background-color: #f4f4f4;
}
.light-row {
  background-color: #ffffff;
}
.custom-row:hover {
  background-color: #e8e8e8;
}
.selectSt {
  margin-bottom: 20px;
  margin-left: 20px;
  margin-top: 6px;
}
.subtitle-lines > div {
  margin-bottom: 12px;
}
.subtitle-lines > div:last-child {
  margin-bottom: 0;
}
</style>
